const normalize = (value: string) =>
  value.toLowerCase().replace(/[^a-z0-9]+/g, '');

const BLOCKED_TERMS = ['trump', 'truthsocial', 'truth social'].map(normalize);

export const mentionsBlockedTerm = (
  ...values: (string | null | undefined)[]
): boolean =>
  values.some(
    (value) =>
      value != null &&
      BLOCKED_TERMS.some((term) => normalize(value).includes(term)),
  );
